import { IconComponent } from './types';

const SuitabilityIcon: IconComponent = (props) => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 9.75H3.88889V8.125H0V9.75ZM5.05556 9.75H8.94444V8.125H5.05556V9.75ZM10.1111 9.75H14V8.125H10.1111V9.75ZM0 13H1.55556V11.375H0V13ZM3.11111 13H4.66667V11.375H3.11111V13ZM6.22222 13H7.77778V11.375H6.22222V13ZM9.33333 13H10.8889V11.375H9.33333V13ZM12.4444 13H14V11.375H12.4444V13ZM0 6.5H6.22222V4.875H0V6.5ZM7.77778 6.5H14V4.875H7.77778V6.5ZM0 0V3.25H14V0H0Z"
      fill="currentColor"
    />
  </svg>
);

export default SuitabilityIcon;
